/**
 *
 * @param {string} dEvent
 * @param {*} context
 * @param {?Object|boolean} options
 */
exports.dispatchEvent = (dEvent, context = document, options = false) => {
  let event;
  options = options || { bubbles: false, cancelable: false, detail: undefined };
  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(dEvent, { detail: options.detail });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(
      dEvent,
      options.bubbles,
      options.cancelable,
      options.detail
    );
  }
  context.dispatchEvent(event);
};
